// Outils de dates communs au calendrier et au journal d'entrainement (mois
// affiche en 6 semaines, du lundi au dimanche).

export const JOURS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export function iso(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function ajouterJours(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

// 6 semaines (lundi -> dimanche) couvrant le mois affiche.
export function joursAffiches(mois: Date): Date[] {
  const premier = new Date(mois.getFullYear(), mois.getMonth(), 1);
  const decalage = (premier.getDay() + 6) % 7; // lundi = 0
  const debut = ajouterJours(premier, -decalage);
  return Array.from({ length: 42 }, (_, i) => ajouterJours(debut, i));
}

export function formaterKm(m?: number | null): string {
  return m ? `${(m / 1000).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} km` : '';
}

// Fuseau horaire IANA du navigateur (ex Europe/Paris).
export function fuseauNavigateur(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

// Fuseaux horaires proposes (tous ceux connus du navigateur).
export function fuseauxDisponibles(): string[] {
  try {
    const liste = (Intl as unknown as { supportedValuesOf?: (cle: string) => string[] }).supportedValuesOf?.('timeZone');
    if (liste && liste.length) return liste;
  } catch {
    // navigateur ancien
  }
  return [fuseauNavigateur()];
}

// Jour courant (AAAA-MM-JJ) dans un fuseau horaire : celui de l'athlete
// dont on consulte le calendrier, quel que soit le fuseau du navigateur.
// Sans fuseau (ou fuseau inconnu) : le jour du navigateur.
export function aujourdhuiDans(fuseau?: string | null, maintenant: Date = new Date()): string {
  if (!fuseau) return iso(maintenant);
  try {
    const parties = new Intl.DateTimeFormat('en-CA', { timeZone: fuseau, year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(maintenant);
    const v = (type: string) => parties.find((p) => p.type === type)?.value ?? '';
    return `${v('year')}-${v('month')}-${v('day')}`;
  } catch {
    return iso(maintenant);
  }
}
